<template>
  <section class="video-wrap" :style="wrapStyle">
    <div class="w-12r m-a">
      <h2 class="m-0 ta-c ff-asb">
        {{ $t(videoInfo.h2) }}
      </h2>
      <div v-if="isHtml" class="desc-html" v-html="$t(videoInfo.desc)"></div>
      <div v-else class="desc" :style="customStyle">
        <p class="">
          {{ $t(videoInfo.desc) }}
        </p>
      </div>
      <div :class="videoClass">
        <div class="video-box from-bottom w-12r">
          <img
            v-if="videoInfo.isImg"
            height="100%"
            width="100%"
            class="img-box from-bottom"
            :src="videoInfo.poster"
            alt=""
          />
          <video
            v-else
            :class="`video${videoIndex}`"
            class="lazy-video"
            width="100%"
            height="100%"
            x5-playsinline
            x5-video-player-type="h5"
            x-webkit-airplay="allow"
            playsinline
            webkit-playsinline
            muted
            loop
            controls
            autoplay
            :poster="videoInfo.poster"
            :src="videoInfo.src"
            :data-src="videoInfo.src"
          ></video>
        </div>
        <slot />
      </div>
    </div>
  </section>
</template>

<script>
  // import { gsap } from 'gsap'

  export default {
    props: {
      videoIndex: {
        type: [Number, String],
        default: ''
      },
      videoInfo: {
        required: true,
        type: Object,
        default: () => {}
      },
      customStyle: {
        type: Object,
        default: () => {}
      },
      wrapStyle: {
        type: Object,
        default: () => {}
      },
      videoClass: {
        type: String,
        default: ''
      },
      isHtml: {
        type: Boolean,
        default: false
      }
      // customVideoStyle: {
      //   type: Object,
      //   default: () => {}
      // }
    },
    data() {
      return {}
    },
    created() {},
    mounted() {},
    methods: {}
  }
</script>

<style scoped lang="scss">
  .video-wrap {
    margin-top: 1.6rem;
  }
  .video-wrap h2 {
    font-size: 0.48rem;
    color: #333;
  }

  .video-wrap .video-box {
    height: 5.65rem;
  }
  .video-wrap .img-box {
    height: 4.64rem;
  }
  .video-wrap .desc,
  .area-4 .desc {
    width: 8.96rem;
    text-align: center;
    padding: 0.24rem 0 0.32rem 0;
    margin: 0 auto;
    font-size: 0.18rem;
    color: #666;
  }
  .desc-html {
    text-align: center;
    padding: 0.24rem 0 0.32rem 0;
    margin: 0 auto;
    font-size: 0.18rem;
    color: #666;
  }
</style>
